import React from 'react';
import { motion } from 'framer-motion';
import { DivineBackdrop, OrnateGoldBadge, GoldFooterPill, BODY_FONT_STYLE } from './shared';

const WelcomeDisplay = ({ content }) => (
  <div className="w-full h-full relative overflow-hidden" data-testid="welcome-display" style={{ height: '100vh' }}>
    <DivineBackdrop />
    <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-12">
      <motion.div initial={{ opacity: 0, y: -24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
        <OrnateGoldBadge>{content?.welcome_title || 'WELCOME TO'}</OrnateGoldBadge>
      </motion.div>

      <motion.h1
        initial={{ opacity: 0, scale: 0.92, filter: 'blur(14px)' }}
        animate={{ opacity: 1, scale: 1, filter: 'blur(0px)' }}
        transition={{ delay: 0.25, duration: 0.9, type: 'spring' }}
        className="text-white"
        style={{
          ...BODY_FONT_STYLE,
          fontSize: 'clamp(40px, 8.5vh, 120px)',
          lineHeight: 1.04,
          letterSpacing: '-0.02em',
          margin: '4vh 2vw 1.5vh',
          fontFamily: '"Cinzel", "Playfair Display", Georgia, serif',
        }}
      >
        {content?.church_name || 'CELESTIAL CHURCH OF CHRIST'}
      </motion.h1>

      <motion.div
        initial={{ scaleX: 0, opacity: 0 }} animate={{ scaleX: 1, opacity: 1 }} transition={{ delay: 0.6, duration: 0.6 }}
        style={{
          width: '260px', height: '2.5px', margin: '0.5vh 0 2vh',
          background: 'linear-gradient(90deg, transparent, #fde68a, transparent)',
          boxShadow: '0 0 12px rgba(251,191,36,0.7)',
        }}
      />

      <motion.h2
        initial={{ opacity: 0, y: -14 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.75, duration: 0.5 }}
        className="text-white/90"
        style={{
          ...BODY_FONT_STYLE,
          fontWeight: 800,
          fontSize: 'clamp(22px, 4.2vh, 58px)',
          margin: 0,
          letterSpacing: '0.01em',
        }}
      >
        {content?.parish_name || 'Valley of Berachah Parish'}
      </motion.h2>

      <motion.div
        initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.0, duration: 0.6 }}
        style={{ marginTop: '6vh' }}
      >
        <GoldFooterPill>
          {content?.welcome_subtitle || 'We welcome you into the presence of the Lord'}
        </GoldFooterPill>
      </motion.div>
    </div>
  </div>
);

export default WelcomeDisplay;
